import * as React from 'react';

import { SLACK_INVITE_LINK } from '../../constants';
import './styles.css';

export const Footer = () => {
	return (
		<>
			<section>
				<div className="divider"></div>
			</section>

			<footer>
				<div className="footer-wrapper">
					<div className="links">
						<a
							href="https://graphweaver.com/docs"
							pirsch-event="footer-docs"
							target="_blank"
							rel="noopener noreferrer"
							className="contact-link"
						>
							Docs
						</a>
						<a
							href="https://github.com/exogee-technology/graphweaver"
							pirsch-event="footer-github"
							target="_blank"
							rel="noopener noreferrer"
							className="contact-link"
						>
							GitHub
						</a>
						<a
							href={SLACK_INVITE_LINK}
							pirsch-event="footer-slack"
							target="_blank"
							rel="noopener noreferrer"
							className="contact-link"
						>
							Slack
						</a>
						<a
							href="/contact-us"
							pirsch-event="footer-contact"
							rel="noopener noreferrer"
							className="contact-link"
						>
							Contact
						</a>
					</div>
					<p>Made with 💜 in Australia</p>
					<a
						id="exogee"
						href="https://exogee.com"
						target="_blank"
						rel="noopener noreferrer"
						pirsch-event="exogee-logo"
						className="exogee-logo"
					>
						<img width="108" src="/img/exogee-logo.svg" />
					</a>
				</div>
			</footer>
		</>
	);
};
